import { Injectable, computed, effect, signal } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LangService {
  private currentLangSignal = signal(localStorage.getItem('lang') || 'en');
  currentLang = computed(() => this.currentLangSignal());

  constructor(private translate: TranslateService) {
    this.translate.use(this.currentLang());

    this.translate.onLangChange.subscribe((e: LangChangeEvent) => {
      this.currentLangSignal.set(e.lang);
    });

    effect(() => {
      const lang = this.currentLang();
        const dir = this.getDir();

      localStorage.setItem('lang', lang);
  document.documentElement.setAttribute('lang', lang);
  document.documentElement.setAttribute('dir', dir);
    });
  }

  setLang(lang: string) {
    this.translate.use(lang);
  }

  isRTL = computed(() => ['ar', 'he', 'fa', 'ur'].includes(this.currentLang()));
  getDir = computed(() => this.isRTL() ? 'rtl' : 'ltr');
}
